import React from "react";
import { Box, Paper, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import GridItem from "components/Grid/GridItem";
import UpdateCard from "views/hbg-view/Announcement/updatesCard";
import GridContainer from "components/Grid/GridContainer";
import { useGetAnnouncements } from "api/announcement";
import CustomPagination from "components/CustomPagination/CustomPagination";

const AnnouncementsTable = () => {
  const { data, isLoading: announcementsFetching } = useGetAnnouncements();
  // console.log(data);
  // const { setUrlParams, getUrlParams } = useUrlParams();

  const announcementList = data?.rows || [];
  return (
    <Paper
      elevation={3}
      sx={{ borderRadius: 2, marginTop: "20px", overflow: "hidden" }}
    >
      <Box p={3}>
        <Typography variant="h5" gutterBottom>
          Updates and Announcements
        </Typography>
        <GridContainer gap={2}>
          {announcementList.map((update, index) => (
            <GridItem xs={12} sm={6} key={index}>
              <UpdateCard
                // setAnnouncementId={setAnnouncementId}
                // setEditAnnouncementModal={setEditAnnouncementModal}
                // handleDelete={handleDelete}
                {...update}
              />
            </GridItem>
          ))}
        </GridContainer>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            marginTop: 3,
          }}
        >
          <CustomPagination totalItems={data?.count} defaultPageSize={2} />
        </Box>
      </Box>
    </Paper>
  );
};

export default AnnouncementsTable;
